<script setup lang="ts">
interface Props {
  type?: 'square' | 'rounded';
  size?: 'sm' | 'md' | 'lg';
  color?:
    | 'primary'
    | 'secondary'
    | 'silver'
    | 'gray'
    | 'red'
    | 'yellow'
    | 'warning'
    | 'green'
    | 'blue'
    | 'indigo'
    | 'purple'
    | 'pink';
}

withDefaults(defineProps<Props>(), {
  type: 'rounded',
  color: 'gray',
  size: 'sm',
});
</script>

<template>
  <span
    :class="[
      'inline-flex items-center font-normal',
      {
        'rounded-full': type === 'rounded',
        rounded: type === 'square',
        'px-2.5 py-1 text-xs font-normal': size === 'sm',
        'px-3 py-1.5 text-sm font-normal': size === 'md',
        'px-4 py-2 font-normal': size === 'lg',
      },
      {
        'bg-brand-primary text-stone-50': color === 'primary',
        'bg-brand-secondary text-stone-50': color === 'secondary',
        'bg-brand-silver text-stone-50': color === 'silver',
        'bg-gray-100 text-gray-600': color === 'gray',
        'bg-red-100 text-red-700': color === 'red',
        'bg-yellow-100 text-yellow-800': color === 'yellow',
        'bg-system-warning-yellow text-stone-50': color === 'warning',
        'bg-green-100 text-green-700': color === 'green',
        'bg-blue-100 text-blue-700': color === 'blue',
        'bg-indigo-100 text-indigo-700': color === 'indigo',
        'bg-purple-100 text-purple-700': color === 'purple',
        'bg-pink-100 text-pink-700': color === 'pink',
      },
    ]"
  >
    <slot />
  </span>
</template>

<style scoped lang="scss"></style>
